import { observable, action } from "mobx";
import AWS from 'aws-sdk';
import Promise from 'bluebird';
import moment from 'moment';
import commonStore from "./commonStore";
import * as AWSCognito from "amazon-cognito-identity-js";
import dynamoParams from './dynamodb-param'
import LocalAPI from './Local'
import apigClientFactory from 'aws-api-gateway-client'

const shortid = require('shortid');
const localAPI = new LocalAPI()

const userPool = new AWSCognito.CognitoUserPool({
  UserPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
  ClientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID
});


let destination_table = `destinations-${process.env.REACT_APP_SONIC_ENV}`
let campaign_table = `campaigns-${process.env.REACT_APP_SONIC_ENV}`



let userID = null
let cognitoUser = null;
let dynamodb = null;
let lambda = null
let s3 = null
let apigClient = null
let useremail = null
let sessionTimer

/*
function this.invokeLambda(name, payload) {
  if(lambda){
  const params = {
    // ClientContext: "MyApp",
    FunctionName: name,
    Payload: JSON.stringify(payload)
    // Qualifier: "1"
  };

  return lambda
    .invoke(params)
    .promise()
    .then(result => Promise.resolve(JSON.parse(result.Payload)));
  }else{
    return Promise.resolve({})
  }
}*/

function createAPI(){

  //return null

  //console.log(AWS.config.credentials.accessKeyId)
  //console.log(AWS.config.credentials.secretAccessKey)
  //console.log(AWS.config.credentials.sessionToken)
  console.log(process.env.REACT_APP_API_URL)


  return apigClientFactory.newClient({
    invokeUrl:`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_SONIC_ENV}`, // REQUIRED
    accessKey: AWS.config.credentials.accessKeyId, 
    secretKey:  AWS.config.credentials.secretAccessKey, 
    sessionToken: AWS.config.credentials.sessionToken, 
    region: process.env.REACT_APP_AWS_REGION
  });
}

class AuthStore {

  @observable userSessionValid = false
  @observable userSessionExpired = false
  @observable forgotPasswordDialogVisible = false
  @observable passwordRequested = false
  @observable verificationCodeCompleted = false

  @observable inProgress = false;
  @observable errors = undefined;
  @observable newPasswordRequired = false;
  @observable
  values = {
    email: "",
    password: "",
    code: ""
  };
  @observable message = null;
  @observable currentUser = null;
  @observable oldPassword = "";
  @observable newPassword = "";
  @observable deleteButton = false;

  @observable passwordChangeFailed = false

  @observable stripeKey = process.env.REACT_APP_STRIPE

  @action
  setCurrentUser(userName) {
    this.currentUser = userName;
  }

  @action
  setCode(code) {
    this.values.code = code;
  }

  @action
  setEmail(email) {
    useremail = email
    this.values.email = email;
  }

  @action
  setPassword(password) {
    this.values.password = password;
  }

  @action
  setConfirmPassword(password) {
    this.values.confirmPassword = password;
  }


  @action
  setOldPassword(password) {
    this.oldPassword = password;
  }

  @action
  setNewPassword(password) {
    this.newPassword = password;
  }

  @action
  setDeleteButton(press) {
    this.deleteButton = press;
  }

  @action
  setMessage(message) {
    this.message = message;
  }

  @action
  showForgotPasswordDialog(message) {
    this.forgotPasswordDialogVisible = message;
  }

  @action
  showExpiredSessionDialog(message) {
    this.userSessionExpired = message;
  }

  @action
  setUserSessionValid(message) {
    this.userSessionValid = message;
  }

  @action
  setSessionToken(token) {
    this.userSessionToken = token;
  }


  @action
  reset() {
    this.errors = "";
    this.message = "";
    this.values = {
      email: "",
      password: "",
      code: ""
    };
    this.deleteButton = false;
  }


  @action
  loadApp() {
      commonStore.setAppLoading(true)
      return this.verifySession()
      .then((result) => {
          if(result){
            return this.loadUser() 
          }
          commonStore.setAppLoading(false)
      })
      /*.catch((err) => {
          console.log('loadApp')
          console.log(err)
          this.showExpiredSessionDialog(true)
          commonStore.setAppLoaded(false);
      })*/
      /*.finally(() => {
        commonStore.setAppLoaded(true);
      })*/
  }

  @action
  loadUser() {
    return new Promise((res, rej) => {
      cognitoUser.getUserAttributes((err, attributes) => {
        if (err) {
          return rej(err);
        }
        res(attributes);
      });
    })
    .then(attributes => {
      const attributesToUpdate = { lastLogin: moment().format() };
      return Promise.each(attributes, (item) => {
 
        switch (item.getName()) {
        case 'custom:merchant':
          attributesToUpdate.customerID = item.getValue();
          break;
        case 'custom:buyer':
          attributesToUpdate.buyerID = item.getValue();
          break;
        case 'custom:network':
          attributesToUpdate.networkID = item.getValue();
          break;
        case 'custom:company':
          attributesToUpdate.companyID = item.getValue();
          break;
        case 'custom:corp':
          attributesToUpdate.corpID = item.getValue();
        break;
        case 'custom:typeformLink':
          attributesToUpdate.typeformLink = item.getValue();
          break;
        case 'given_name':
          attributesToUpdate.firstName = item.getValue();
          break;
        case 'family_name':
          attributesToUpdate.lastName = item.getValue();
          break;
        case 'phone_number':
          attributesToUpdate.phone = item.getValue();
          break;
        case 'email':
          attributesToUpdate.email = item.getValue();
          this.setCurrentUser(attributesToUpdate.email);
          break;
        default:
          break;
        }
        return Promise.resolve()
      })
      .then(() => {
        attributesToUpdate.type = 'leads'
        return this.syncUser(attributesToUpdate)
      })
      .then((agent) => {
          console.log(agent)
          const { agentID } = agent
          userID = agentID
          commonStore.setAgent(agent)
          this.getPaymentMethods()
         // this.getFixedCampaigns(['catholics'])
          this.getCampaigns()
          commonStore.setAppLoading(false)
          return Promise.resolve(true)
      });
   })

  }


  @action
  verifySession() {
    console.log('verifySession')
    let hasSession = false;
    Object.keys(localStorage).every(key => {
      if (key.match("CognitoIdentityServiceProvider")) {
        console.log('has session')
        hasSession = true;
      }
      return key;
    });
    return (
      new Promise((res, rej) => {
        if (hasSession) {

          cognitoUser = userPool.getCurrentUser();

          return cognitoUser !== null ? res() : rej(new Error('no user found in userPool'));
        } else {
          return rej(new Error('does not hasSession'));
        }
      })
      .then(() => {
          return new Promise((res, rej) => {
            cognitoUser.getSession((err, session) => {

              //console.log(cognitoUser)

              //console.log(session)

              return err ? rej(err) : res(session.getIdToken().getJwtToken());
            });
          })
          .then(userToken => {

            AWS.config.update({ region: process.env.REACT_APP_AWS_REGION});
            const authenticator = `cognito-idp.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID}`;
            AWS.config.credentials = new AWS.CognitoIdentityCredentials({
              IdentityPoolId: process.env.REACT_APP_AWS_IDENTITY_POOL_ID,
              Logins: {
                [authenticator]: userToken
              }
            });

            this.setSessionToken(userToken)
            return AWS.config.credentials.getPromise()
          })
          .then(() => {
              dynamodb = new AWS.DynamoDB.DocumentClient({
                endpoint: process.env.REACT_APP_AWS_DB_END_POINT,
                region: process.env.REACT_APP_AWS_REGION
              });
              lambda = new AWS.Lambda();
              s3 = new AWS.S3()
              apigClient = createAPI()
              return Promise.resolve()
          })
      })
      .then(() => {
        commonStore.setAppLoaded(true);
        this.showExpiredSessionDialog(false)
        this.setUserSessionValid(true)
        return Promise.resolve(true)
      })
      .catch((err) => {
          this.setCurrentUser(null);
          if(this.userSessionValid){
            this.showExpiredSessionDialog(true)
          }
          this.setUserSessionValid(false)
      })
      .finally(() => {
        commonStore.setAppLoaded(true);
        clearTimeout(sessionTimer)
        sessionTimer = setTimeout(() => { this.verifySession() }, 1800000);
      })
    );
  }


/*
  @action
  verifySession() {
    let hasSession = false;
    Object.keys(localStorage).every(key => {
      if (key.match("CognitoIdentityServiceProvider")) {
        console.log('has session')
        hasSession = true;
      }
      return key;
    });
    return (
      new Promise((res, rej) => {
        if (hasSession) {

          cognitoUser = userPool.getCurrentUser();

          return cognitoUser !== null ? res() : rej(new Error('no user found in userPool'));
        } else {
          return rej(new Error('does not hasSession'));
        }
      })
      .then(() => {
          return new Promise((res, rej) => {
            cognitoUser.getSession((err, session) => {

              return err ? rej(err) : res(session.getIdToken().getJwtToken());
            });
          })
          .then(userToken => {

            AWS.config.update({ region: process.env.REACT_APP_AWS_REGION});
            const authenticator = `cognito-idp.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID}`;
            AWS.config.credentials = new AWS.CognitoIdentityCredentials({
              IdentityPoolId: process.env.REACT_APP_AWS_IDENTITY_POOL_ID,
              Logins: {
                [authenticator]: userToken
              }
            });
            return AWS.config.credentials.getPromise()
          })
          .then(() => {
              dynamodb = new AWS.DynamoDB.DocumentClient({
                endpoint: process.env.REACT_APP_AWS_DB_END_POINT,
                region: process.env.REACT_APP_AWS_REGION
              });
              lambda = new AWS.Lambda();
              s3 = new AWS.S3()
              apigClient = createAPI()
              return Promise.resolve()
          })
      })
      .then(() => {
          return new Promise((res, rej) => {
            cognitoUser.getUserAttributes((err, attributes) => {
              if (err) {
                return rej(err);
              }
              res(attributes);
            });
          })
          .then(attributes => {
            const attributesToUpdate = { lastLogin: moment().format() };
            return Promise.each(attributes, (item) => {
       
              switch (item.getName()) {
              case 'custom:merchant':
                attributesToUpdate.customerID = item.getValue();
                break;
              case 'custom:buyer':
                attributesToUpdate.buyerID = item.getValue();
                break;
              case 'custom:network':
                attributesToUpdate.networkID = item.getValue();
                break;
              case 'custom:company':
                attributesToUpdate.companyID = item.getValue();
                break;
              case 'custom:typeformLink':
                attributesToUpdate.typeformLink = item.getValue();
                break;
              case 'given_name':
                attributesToUpdate.firstName = item.getValue();
                break;
              case 'family_name':
                attributesToUpdate.lastName = item.getValue();
                break;
              case 'phone_number':
                attributesToUpdate.phone = item.getValue();
                break;
              case 'email':
                attributesToUpdate.email = item.getValue();
                this.setCurrentUser(attributesToUpdate.email);
                break;
              default:
                break;
              }
              return Promise.resolve()
            })
            .then(() => {
              attributesToUpdate.type = 'leads'
              return this.syncUser(attributesToUpdate)
            })
            .then((agent) => {
                commonStore.setAgent(agent)
                this.getPaymentMethods()
                return Promise.resolve()
            });
         })
      })
      .then(() => {
        return Promise.resolve(true)
      })
      .catch((err) => {
        //neeed to report and handle error
          this.setCurrentUser(null);
          commonStore.setAppLoaded(false);
      })
      .finally(() => {
        commonStore.setAppLoaded(true);
      })
    );
  }
*/
  @action
  login() {
    commonStore.setSignInError('')
    commonStore.setLoading(true);
    this.inProgress = true;
    this.errors = undefined;
    let email = this.values.email;

    if (email === ''){
      email = useremail
    }

    let authenticationDetails = new AWSCognito.AuthenticationDetails({
      Username: email,
      Password: this.values.password
    });

    cognitoUser = new AWSCognito.CognitoUser({
      Username: email,
      Pool: userPool
    });

    return new Promise((res, rej) => {
          cognitoUser.authenticateUser(authenticationDetails, {
            onSuccess: result => {
              commonStore.setLoading(false);
              console.log(result)
              if(result){
                return res(true);
              }
              return rej(new Error('No Login Result. Refresh Your Browser'));
            },
            onFailure: err => {
              commonStore.setLoading(false);
              commonStore.setSignInError(err)
              console.log(err)

              return rej(err);
            },
            newPasswordRequired: (userAttributes, requiredAttributes) => {
              commonStore.setLoading(false);
              this.newPasswordRequired = true
              delete userAttributes.email_verified
              this.values.userAttributes = userAttributes
              useremail = email
              return res(false);
              // User was signed up by an admin and must provide new
              // password and required attributes, if any, to complete
              // authentication.
              // console.log('newPasswordRequired');
              // console.log('newPasswordRequired');
              // the api doesn't accept this field back
            }
          });
      })
      .then(result => {
        if (result) {
          commonStore.setLoading(true);
          //return this.verifySession()
          return this.loadApp()
        }
        return Promise.resolve(result)
   
      })
      .catch(
        action(err => {
          this.errors = this.simpleErr(err);
          throw err;
        })
      )
      .finally(
        action(() => {
          commonStore.setLoading(false);
          this.inProgress = false;
        })
      );
  }

@action
 forgotPW(email, sendResponse){
   
    var userData = {
        Username : this.values.email,
        Pool : userPool
     };

    cognitoUser = new AWSCognito.CognitoUser(userData);
        commonStore.setSignInError('')
        commonStore.setLoading(true);
        cognitoUser.forgotPassword({
            onSuccess: result => {
                commonStore.setLoading(false);
                this.showForgotPasswordDialog(false)
            },
            onFailure: err => {
                commonStore.setLoading(false);
                commonStore.setSignInError(err)
                this.showForgotPasswordDialog(false)
            },
            inputVerificationCode: () => {
                commonStore.setLoading(false);
                this.showInputVerification()

            }
          })
}

@action
showInputVerification = () => {

 this.passwordRequested = true

}


@action
 confirmPW = (verificationCode, newPassword) => {
  commonStore.setSignInError('')
  commonStore.setLoading(true);
  cognitoUser.confirmPassword(verificationCode, newPassword, {
    onSuccess: result => {
      console.log(result)
      commonStore.setLoading(false);
      this.showForgotPasswordDialog(false)
    },
    onFailure: err => {
      console.log(err)
      this.showForgotPasswordDialog(false)
      commonStore.setLoading(false);
      commonStore.setSignInError(err)
    }
  }
  )
}

@action
createNewPassword() {
    const password = this.values.password
    const userAttributes = this.values.userAttributes
    const confirmedPassword = this.values.confirmPassword

    commonStore.setSignInError('')
    commonStore.setLoading(true);

  return new Promise((res, rej) => {
      cognitoUser.completeNewPasswordChallenge(password, userAttributes, {
        onSuccess: result => {
          console.log(result)
          return res();
       
         },
         onFailure: err => {
          console.log(err)
           return rej(err);
         }
      })
    })
    .then(() => {
      console.log('should log in')
        this.login()
    })
    .catch(
      action(err => {
        commonStore.setSignInError(err)
        this.errors = this.simpleErr(err);
        throw err;
      })
    )
    .finally(
      action(() => {
        commonStore.setLoading(true);
        this.inProgress = false;
      })
    );
  }
  @action
  register() {
    this.inProgress = true;
    this.errors = undefined;

    return new Promise((res, rej) => {
      userPool.signUp(
        this.values.email,
        this.values.password,
        null,
        null,
        (err, result) => {
          if (err) {
            return rej(err);
          }
          cognitoUser = result;
          res();
        }
      );
    })
      .catch(
        action(err => {
          this.errors = this.simpleErr(err);
          throw err;
        })
      )
      .finally(
        action(() => {
          this.inProgress = false;
        })
      );
  }

  @action
  confirmCode() {
    this.inProgress = true;
    this.errors = undefined;

    cognitoUser = new AWSCognito.CognitoUser({
      Username: this.values.email,
      Pool: userPool
    });

    return new Promise((res, rej) => {
      cognitoUser.confirmRegistration(this.values.code, true, err => {
        return err ? rej(err) : res();
      });
    })
      .then(
        action(() => {
          this.setMessage("You're confirmed! Please login...");
        })
      )
      .catch(
        action(err => {
          this.errors = this.simpleErr(err);
          throw err;
        })
      )
      .finally(
        action(() => {
          this.inProgress = false;
        })
      );
  }

  @action
  logout() {
    console.log('logout')
    return new Promise(res => {
      console.log(cognitoUser)
   
      if (cognitoUser !== null) {

        cognitoUser.signOut();
        useremail = null
        cognitoUser = null;
      }
      this.setCurrentUser(null);
      res();
    });
  }

  @action
  changePassword() {
    this.inProgress = true;
    this.errors = undefined;

    return new Promise((res, rej) => {
      cognitoUser.changePassword(
        this.oldPassword,
        this.newPassword,
        (err, result) => {
          if (err) {
            return rej(err);
          }
          return res();
        }
      );
    })
      .then(
        action(() => {
          this.setMessage("Changes saved.");
        })
      )
      .catch(
        action(err => {
          this.errors = this.simpleErr(err);
          throw err;
        })
      )
      .finally(
        action(() => {
          this.inProgress = false;
        })
      );
  }

  @action
  deleteAccount() {
    this.inProgress = true;
    this.errors = undefined;

    return new Promise((res, rej) => {
      if (!this.deleteButton) {
        return rej({
          message: "To delete your account please click the checkbox."
        });
      }
      cognitoUser.deleteUser((err, result) => {
        if (err) {
          return rej(err);
        }
        window.localStorage.clear();
        this.setCurrentUser(null);
        return res();
      });
    })
      .catch(
        action(err => {
          this.errors = this.simpleErr(err);
          throw err;
        })
      )
      .finally(
        action(() => {
          this.inProgress = false;
        })
      );
  }


  @action
  getUser(){
    return this.invokeLambda('accountManager', {})
      .then((result) => {
        console.log(result)
        return Promise.resolve(result);
      })  
  };  

/*  
@action
getUser(item){

  const currentUser = userPool.getCurrentUser();
  const agentID = currentUser.storage[`aws.cognito.identity-id.${process.env.REACT_APP_AWS_IDENTITY_POOL_ID}`];
  const params = {};
  params.TableName = 'agents';
  params.Key = { agentID, profileID: 'default' }; // need to generalize

  return dynamodb.get(params).promise()
    .then((result) => {
      if ('Message' in result) {
        return Promise.reject(new Error(JSON.stringify(result)));
      } else if ('Attributes' in result) {
        return Promise.resolve(result.Attributes);
      } else if ('Item' in result) {
        return Promise.resolve(result.Item);
      } else {
        console.error(new Error(`No Data Returned from Dynamo verifySuccess: ${JSON.stringify(result)}${moment().format()}`));
        return Promise.reject(new Error('ERROR No User Found!'));
      }
    });
  }*/


  @action
  syncUser = (item) => {
    return this.invokeLambda('accountManager', item)
      .then((result) => {
        console.log(result)
        commonStore.setAgent(result)
     //   this.getFixedCampaigns(['catholics'])
        return Promise.resolve(result);
      })  
  };


  getFixedCampaigns = (campaigns) => {
  
  return this.invokeAPI('POST', '/network/getFixedCampaign', campaigns)
    .then((result) => {
      console.log(result)
    })
    .catch((err) => {
      console.log(err);
    });
  };


  /*
@action
syncUser(item){
  const currentUser = userPool.getCurrentUser();

  const agentID = currentUser.storage[`aws.cognito.identity-id.${process.env.REACT_APP_AWS_IDENTITY_POOL_ID}`];
  item.agentID = agentID
  item.profileID = 'default'

  return dynamoParams('agents', item, 'ALL_NEW', 'agentID', 'profileID')
  .then(params => {
    return dynamodb.update(params).promise()
        .then((result) => {
          if ('Message' in result) {
            return Promise.reject(new Error(JSON.stringify(result)));
          } else if ('Attributes' in result) {
            return Promise.resolve(result.Attributes);
          } else if ('Item' in result) {
            return Promise.resolve(result.Item);
          } else {
            console.error(new Error(`No Data Returned from Dynamo verifySuccess: ${JSON.stringify(result)}${moment().format()}`));
            // return Promise.reject(new Error(JSON.stringify(result)))
            return Promise.resolve();
          }
        });
    });
};
*/



@action
updateCampaign(campaign, start, end){
  console.log('campaign')
  console.log(JSON.stringify(campaign))

///////TEST
  //return Promise.resolve()
///////TEST

  const { campaignID, campaignStatus } = campaign
  commonStore.setLoading(true);
  commonStore.updateItem(campaign_table, campaign, 'campaign')

  const method = campaignID ? 'POST' : 'PUT'

  return this.invokeAPI(method, '/campaign', campaign)
  .then((result) => {
    console.log(result)
    if('campaignID' in result){
      result.id = result.campaignID
      if('balance' in result){
        const formattedBalance = `$${(result.balance / 100).toLocaleString()}`
        result.formattedBalance = formattedBalance
      }
      if('campaignCreated' in result){
        const created = moment(result.campaignCreated).format('MM/DD h:mm a')
        result.campaignCreated = created
      }
      
      if(campaignStatus === 'deleted'){
        commonStore.deleteCampaign(campaignID)
      }else{
        commonStore.updateItem(campaign_table, result, 'campaign')
      }
   
      return Promise.resolve(true)
    }
    return Promise.resolve(false)
  
  })
  .catch((err) => {
    console.log(err);
    return Promise.resolve(false)
  })
.finally(() => {
    commonStore.setLoading(false);
    this.syncUser()
 //   return this.getCampaigns(start, end)
  })

  /*return this.invokeLambda('agentCampaignManager', campaign)
    .then((result) => {
      console.log('updateCampaign')
      console.log(result)
      commonStore.updateItem('campaigns', result, 'campaign')
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
      commonStore.setCampaignsLoading(false);
    })*/

};


@action
updateDestination(item){
  console.log('updateDestination')
  console.log(item)
  const { agent } = commonStore
  const { agentID } = agent
  const modified = moment().format()
  //const destID = shortid.generate()
  const payload = {...item, agentID }

  console.log(payload)

  return dynamoParams(destination_table, payload, 'ALL_NEW', 'agentID', 'destID')
  .then(params => {
    return dynamodb.update(params).promise()
        .then((result) => {
          console.log(result)
          if ('Message' in result) {
            return Promise.reject(new Error(JSON.stringify(result)));
          } else if ('Attributes' in result) {
            return Promise.resolve(result.Attributes);
          } else if ('Item' in result) {
            return Promise.resolve(result.Item);
          } else {
            console.error(new Error(`No Data Returned from Dynamo verifySuccess: ${JSON.stringify(result)}${moment().format()}`));
            // return Promise.reject(new Error(JSON.stringify(result)))
            return Promise.resolve();
          }
        });
    })
    .then(item => {  
        console.log(item)
        commonStore.setDestination(item)
        return Promise.resolve()
    })
};




@action
updateLead(item){
  console.log(item)
  const { leadID,  lastResult } = item


  commonStore.setLoading(true);
  commonStore.setLead(item)
  
  return this.invokeLambda('leadManager', item)
    .then((result) => {
      console.log(result)
      commonStore.updateItem('leads', {leadID, lastResult}, false)
      return Promise.resolve(true)
    })
    .catch((err) => {
      console.log(err);
      return Promise.resolve(false)
    })
    .finally(() => {
      commonStore.setLoading(false);
    })
};





@action
getDestinations(agentID){
 // commonStore.setDestinationsLoading(true);
    const params = {
      TableName: destination_table,
      KeyConditionExpression: 'agentID = :agentID',
      ExpressionAttributeValues: {
        ':agentID': agentID,
      }
    };

    console.log(params)
    return dynamodb.query(params).promise()
    .then((result) => {
      console.log(result)
      if ('Message' in result) {
        return Promise.reject(new Error(JSON.stringify(result)));
      } else if ('Attributes' in result) {
        return Promise.resolve(result.Attributes);
      } else if ('Item' in result) {
        return Promise.resolve(result.Item);
      } else if ('Items' in result) {
        return Promise.resolve(result.Items);
      }else {
        console.error(new Error(`No Data Returned from Dynamo verifySuccess: ${JSON.stringify(result)}${moment().format()}`));
        return Promise.reject(new Error('ERROR No User Found!'));
      }
    })
    .then(items => {  
      commonStore.setDestinations(items)
    })
}


@action
getBatchCampaigns(){
  const { campaigns } = commonStore
  console.log('getBatchCampaigns db')
    return Promise.map(campaigns, campaign => {
        const { agentID, campaignID} = campaign
        return { agentID, campaignID}
    })
    .then(items => {  
      console.log(items)

        const params =  {
          RequestItems: {
            [campaign_table]: {
                  Keys: items
        }}}

        console.log(params)

        return dynamodb.batchGet(params).promise()
          .then((result) => {
            console.log(result)
            if ('Message' in result) {
              return Promise.reject(new Error(JSON.stringify(result)));
            } else if ('Responses' in result) {
              const { [campaign_table]: campaigns } = result.Responses
              return Promise.resolve(campaigns);
            }else {
              console.error(new Error(`No Data Returned from Dynamo verifySuccess: ${JSON.stringify(result)}${moment().format()}`));
              return Promise.reject(new Error('ERROR No User Found!'));
            }
          })
          .then(items => {  
              commonStore.setCampaigns(items)
              return Promise.resolve(true)
          })
    })
    .catch((err) => {
      commonStore.setLoading(false);
      console.log(err);
      return Promise.resolve(false)
    });
}

@action
getCampaigns(){

  const { agent } = commonStore
  const { agentID } = agent

  //const destID = shortid.generate()


  console.log('getCampaigns db')
  commonStore.setLoading(true);
    const params = {
      TableName: campaign_table,
      KeyConditionExpression: 'agentID = :agentID',
      ExpressionAttributeValues: {
        ':agentID': agentID,
      }
    };

    commonStore.setLoading(false);
    //return //REMOVE FOR TEST ONLY

    console.log(params)
    return dynamodb.query(params).promise()
    .then((result) => {
      console.log(result)
      if ('Message' in result) {
        return Promise.reject(new Error(JSON.stringify(result)));
      } else if ('Attributes' in result) {
        return Promise.resolve(result.Attributes);
      } else if ('Item' in result) {
        return Promise.resolve(result.Item);
      } else if ('Items' in result) {
        return Promise.resolve(result.Items);
      }else {
        console.error(new Error(`No Data Returned from Dynamo verifySuccess: ${JSON.stringify(result)}${moment().format()}`));
        return Promise.reject(new Error('ERROR No User Found!'));
      }
    })
    .then(items => {  
        commonStore.setCampaigns(items)
        return Promise.resolve(true)
    })
    .catch((err) => {
      commonStore.setLoading(false);
      console.log(err);
      return Promise.resolve(false)
    });
}


@action
getSupportCases(){

  const { agent } = commonStore
  const { agentID } = agent

  console.log('getSupportCases db')

    const params = {
      TableName: 'agent_service-prod',
      KeyConditionExpression: 'agentID = :agentID',
      ExpressionAttributeValues: {
        ':agentID': agentID,
      }
    };

  
    //return //REMOVE FOR TEST ONLY

    console.log(params)
    return dynamodb.query(params).promise()
    .then((result) => {
      console.log(result)
      if ('Message' in result) {
        return Promise.reject(new Error(JSON.stringify(result)));
      } else if ('Attributes' in result) {
        return Promise.resolve(result.Attributes);
      } else if ('Item' in result) {
        return Promise.resolve(result.Item);
      } else if ('Items' in result) {
        return Promise.resolve(result.Items);
      }else {
        console.error(new Error(`No Data Returned from Dynamo verifySuccess: ${JSON.stringify(result)}${moment().format()}`));
        return Promise.reject(new Error('ERROR No User Found!'));
      }
    })
    .then(items => {  
        commonStore.setSupportCases(items)
        return Promise.resolve(true)
    })
    .catch((err) => {
      console.log(err);
      return Promise.resolve(false)
    });
}

/*
@action
getCampaigns(startDate, endDate){
  console.log('getCampaigns')
  console.log(startDate)
  console.log(endDate)
  commonStore.setLoading(true);
  const payload =  {startDate, endDate, size: 500, count: 0}
  return this.invokeLambda('campaignSearch', payload)
    .then((result) => {
      console.log(result)
      commonStore.setCampaigns(result.hits.hits)
      return Promise.resolve(true)
    })
    .catch((err) => {
      console.log(err);
      return Promise.resolve(false)
    });
};*/

@action
getCampaign(campaignID){
  commonStore.setLoading(true);
  const payload =  {campaignID}
  return this.invokeLambda('campaignSearch', payload)
    .then((result) => {
      console.log(result)
      return commonStore.setCampaign(result)
    })
    .catch((err) => {
      console.log(err);
    });
};

@action
getCampaignBalance = (campaignID) => {
  
  return this.invokeAPI('POST', '/campaign/balance', {campaignID})
    .then((result) => {
      console.log(result)
    })
    .catch((err) => {
      console.log(err);
    });
};


@action
getLeads(params){
  console.log('getLeads')
  commonStore.setLoading(true);
  
  //const { startDate, endDate, commentID, lastResult } = params

  //const payload =  {startDate, endDate, size: 25, count: 0}
 // console.log(payload)
 console.log(params)
  return this.invokeLambda('portalLeadSearch', params)
    .then((result) => {
      console.log(result)
      commonStore.setLeads(result)
      return Promise.resolve(true)
    })
    .catch((err) => {
      console.log(err);
      commonStore.setLoading(false);
      return Promise.resolve(false)
    });
};


@action
getMoreLeads(scrollID){
  console.log('getMoreLeads')
  commonStore.setLoading(true);
  
  const payload =  {scrollID}
  console.log(payload)
  return this.invokeLambda('portalLeadSearch', payload)
    .then((result) => {
      console.log(result)
      commonStore.addScrollLeads(result)
      return Promise.resolve(true)
    })
    .catch((err) => {
      console.log(err);
      return Promise.resolve(false)
    });
};

@action
getNowLeads(params){

  console.log('getNowLeads')
  console.log(params)
  
  return this.invokeLambda('portalLeadSearch', params)
    .then((result) => {
      console.log(result)
      commonStore.addNowLeads(result)
      return Promise.resolve(true)
    })
    .catch((err) => {
      console.log(err);
      return Promise.resolve(false)
    });
};

@action
getPaymentMethods(payment)  {
  console.log('getPaymentMethods');
  console.log(payment)
  //commonStore.setPaymentMethodStatus({isProcessing: true})

  return this.invokeLambda('stripeCustomerManager', {type: 'customer'})
      .then((result) => {
        console.log(result)
        commonStore.setCustomer(result)
    //    commonStore.setPaymentMethodStatus({result: 'success', isProcessing: false})
      })
      .catch((err) => {
        console.log(err)
  //      commonStore.setPaymentMethodStatus({result:'error', message: err, isProcessing: false})
      })
  };


/* Processing Actions */
@action
addPaymentMethod(payment)  {
  console.log('addPaymentMethodToUser');
  console.log(payment)
  commonStore.setPaymentProgress({isProcessing: true})

  return this.invokeLambda('stripePaymentManager', payment)
      .then((result) => {
        console.log(result)
        commonStore.setCustomer(result)
        commonStore.setPaymentProgress({result: 'success', message: 'Payment Method Succesfully Added!', isProcessing: false, type: 'addMethod'})
      })
      .catch((err) => {
        console.log(err)
        commonStore.setPaymentProgress({result:'error', message: err, isProcessing: false, type: 'addMethod'})
      })
  };


@action
addToAvailibleCredit = (card) =>  {
  console.log('addToAvailibleCredit');
  commonStore.setPaymentProgress({isProcessing: true})

  return this.invokeLambda('stripePaymentManager', card)
        .then((result) => {
          console.log(result)
          commonStore.setPaymentProgress({result: 'success', message:'Credit Successfully Added to Your Sonic Account!', isProcessing: false, type:'addCredit'})
        })
        .catch((err) => {
          console.log(err)
          commonStore.setPaymentProgress({result:'error', message: err, isProcessing: false, type:'addCredit'})
        })
  };

invokeAPI = (method, pathTemplate, body) => {

    const pathParams = {};
    const additionalParams = {headers: {},queryParams: {}};

    if(process.env.REACT_APP_SONIC_LOCAL !== 'true'){
      console.log('using aws api')
      console.log(pathTemplate)
      console.log(method)
      return apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams, body)
      .then((result) => {
          const { data } = result
          return Promise.resolve(data)
      })
    }



    console.log('using local api')


    switch(method){
      case 'GET':
      return localAPI.get(pathTemplate, body, 'portal', userID)
      case 'PUT':
      return localAPI.put(pathTemplate, body, 'portal', userID)
      case 'POST':
      return localAPI.post(pathTemplate, body, 'portal', userID)
      case 'PATCH':
      return localAPI.patch(pathTemplate, body,'portal', userID)
      defualt:
      return Promise.reject(new Error(`${method} not availible`))
    }

}

invokeLambda = (name, payload) => {

  let functionName = `${name}-${process.env.REACT_APP_SONIC_ENV}`

  if(lambda){
  const params = {
    // ClientContext: "MyApp",
    FunctionName: functionName,
    Payload: JSON.stringify(payload)
    // Qualifier: "1"
  };

  return lambda
    .invoke(params)
    .promise()
    .then(result => Promise.resolve(JSON.parse(result.Payload)));
  }else{
    return Promise.resolve({})
  }
}

  simpleErr(err) {
    return {
      statusCode: err.statusCode,
      code: err.code,
      message: err.message
    };
  }
}

export default new AuthStore();




// WEBPACK FOOTER //
// ./src/stores/authStore.js